export const removeEmptyValues = item => item !== '';
